import { _ as s } from "./tslib.es6-7f1b1220.js";
import { c as r, u as n, s as i, h as e, n as t } from "./lit-element-161a1699.js";
import { p as o, c as a } from "./decorators-7e9cd43b.js";
import "./BaseElement.esm.min.js";
import { h as p } from "./host.styles-cf05db22.js";
import { i as h } from "./if-defined-123567fc.js";
import { s as g } from "./style-map-a37d7105.js";
import { IconBaseElement as l } from "./icon-base-element.class.esm.min.js";
const z = r`${n("@keyframes progress-rotation {\n  from {\n    transform: rotate(-90deg);\n  }\n  to {\n    transform: rotate(270deg);\n  }\n}\n@keyframes progress-stretch {\n  0% {\n    stroke-dasharray: 40%, 300%;\n  }\n  50% {\n    stroke-dasharray: 120%, 300%;\n  }\n  100% {\n    stroke-dasharray: 40%, 300%;\n  }\n}\n:host {\n  --zui-progress-ring-animation-duration: 1.33s;\n  --zui-progress-ring-animation-timing: cubic-bezier(0.4, 0.1, 0.6, 0.9);\n  --zui-progress-ring-rail-opacity: 1;\n  --zui-progress-ring-rail-color: inherit;\n  --zui-progress-ring-progress-color: inherit;\n  ---zui-progress-ring-size: inherit;\n  ---zui-progress-ring-width: inherit;\n  display: inline-block;\n  height: var(--zui-progress-ring-size);\n  width: var(--zui-progress-ring-size);\n  overflow: hidden;\n  position: relative;\n}\n\ndiv.host {\n  height: var(---zui-progress-ring-size);\n  width: var(---zui-progress-ring-size);\n  display: flex;\n}\n\nsvg {\n  height: 100%;\n  width: 100%;\n  transform: rotate(-90deg);\n  transform-box: fill-box;\n  transform-origin: center center;\n}\n\n.rail,\n.progress {\n  stroke-width: var(---zui-progress-ring-width);\n  stroke-linecap: butt;\n  stroke-linejoin: miter;\n  fill-opacity: 0;\n}\n\n.rail {\n  opacity: var(--zui-progress-ring-rail-opacity);\n  stroke: var(--zui-progress-ring-rail-color);\n}\n\n.progress {\n  stroke: var(--zui-progress-ring-progress-color);\n  transform-box: fill-box;\n  transform-origin: center center;\n}\n\n:host([mode=activity]) svg {\n  animation: var(--zui-progress-ring-animation-duration) progress-rotation infinite var(--zui-progress-ring-animation-timing) 0.15s;\n}\n:host([mode=activity]) .progress {\n  animation: var(--zui-progress-ring-animation-duration) progress-stretch infinite var(--zui-progress-ring-animation-timing);\n  stroke-dasharray: 40%, 300%;\n  stroke-dashoffset: 0;\n}\n\n:host([emphasis=default]) {\n  --zui-progress-ring-rail-color: var(--zui-color-progress-ring-default-background);\n  --zui-progress-ring-progress-color: var(--zui-color-progress-ring-default-foreground);\n}\n\n:host([emphasis=active]),\n:host([emphasis=highlight]) {\n  --zui-progress-ring-rail-color: var(--zui-color-progress-ring-highlight-background);\n  --zui-progress-ring-progress-color: var(--zui-color-progress-ring-highlight-foreground);\n}\n\n:host([emphasis=active-primary]),\n:host([emphasis=primary-highlight]) {\n  --zui-progress-ring-rail-opacity: 0.3;\n  --zui-progress-ring-rail-color: var(--zui-color-progress-ring-primary-highlight-background);\n  --zui-progress-ring-progress-color: var(--zui-color-progress-ring-primary-highlight-foreground);\n}\n\n/* show percent value */\n:host {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n:host span {\n  white-space: nowrap;\n}\n\n/* sizing span */\n:host([size=l]) span,\n:host([size=s80]) span,\n:host([size=s72]) span {\n  font: var(--zui-typography-h3);\n}\n\n:host([size=s]) span,\n:host([size=m]) span,\n:host([size=s64]) span,\n:host([size=s48]) span,\n:host([size=s32]) span,\n:host([size=s24]) span,\n:host([size=s16]) span {\n  font: var(--zui-typography-body);\n}\n\n:host([size=s12]) span,\n:host([size=s8]) span {\n  display: none;\n}\n\n/* colors span */\n:host([emphasis=default]) span {\n  color: var(--zui-color-progress-ring-default-text);\n}\n\n:host([emphasis=highlight]) span {\n  color: var(--zui-color-progress-ring-highlight-text);\n}\n\n:host([emphasis=primary-highlight]) span {\n  color: var(--zui-color-progress-ring-primary-highlight-text);\n}\n\n/* positioning span */\n:host([size=l]) span,\n:host([size=s80]) span,\n:host([size=s72]) span {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n:host([size=m]),\n:host([size=s64]),\n:host([size=s48]),\n:host([size=s32]) {\n  flex-direction: column;\n}\n:host([size=m]) span,\n:host([size=s64]) span,\n:host([size=s48]) span,\n:host([size=s32]) span {\n  margin-top: 2px;\n}\n\n:host([size=s24]),\n:host([size=s16]),\n:host([size=s]) {\n  flex-direction: row;\n}\n:host([size=s24]) span,\n:host([size=s16]) span,\n:host([size=s]) span {\n  margin-left: 5px;\n}\n\n:host([size=s24]) span,\n:host([size=s]) span {\n  margin-bottom: 1px;\n}")}`,
  c = {
    s: {
      size: 16,
      stroke: 2
    },
    m: {
      size: 32,
      stroke: 3
    },
    l: {
      size: 72,
      stroke: 4
    },
    s8: {
      size: 8,
      stroke: 1
    },
    s12: {
      size: 12,
      stroke: 1
    },
    s16: {
      size: 16,
      stroke: 2
    },
    s24: {
      size: 24,
      stroke: 3
    },
    s32: {
      size: 32,
      stroke: 3
    },
    s48: {
      size: 48,
      stroke: 4
    },
    s64: {
      size: 64,
      stroke: 4
    },
    s72: {
      size: 72,
      stroke: 4
    },
    s80: {
      size: 80,
      stroke: 4
    }
  },
  m = {
    s: "s12",
    m: "s16",
    l: "s24"
  };
let u = class extends l {
  constructor() {
    super(...arguments), this.mode = "activity", this.emphasis = "default", this.size = "s32", this.asIcon = !1, this.showPercent = !1, this.value = 0;
  }
  static get styles() {
    return [p, z];
  }
  get _correctedValue() {
    const s = Math.min(Math.max(this.value, 0), 100);
    return Math.floor(s);
  }
  get _internalStroke() {
    var s;
    return c[this.asIcon && null !== (s = m[this.size]) && void 0 !== s ? s : this.size].stroke;
  }
  get _internalSize() {
    var s;
    return c[this.asIcon && null !== (s = m[this.size]) && void 0 !== s ? s : this.size].size;
  }
  _renderCircle(s) {
    const r = (this._internalSize - this._internalStroke) / 2,
      n = this._internalSize / 2,
      e = this._internalStroke / 2,
      t = 2 * r * Math.PI,
      o = t - t * this._correctedValue / 100,
      a = "progress" === this.mode && "progress" === s;
    return i`<circle class="${s}" r="${r}" cx="${n}" cy="${n}" stroke-miterlimit="${e}" stroke-dasharray="${h(a ? t : void 0)}" stroke-dashoffset="${h(a ? o : void 0)}">`;
  }
  update(s) {
    super.update(s), s.has("emphasis") && ("active" !== this.emphasis && "active-primary" !== this.emphasis || console.warn(`Deprecated emphasis: ${this.emphasis} was used on zui-progress-ring.`));
  }
  render() {
    return e`<div class="host" style="${g({
      "---zui-progress-ring-size": `${this._internalSize}px`,
      "---zui-progress-ring-width": `${this._internalStroke}px`
    })}">${i`<svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 ${this._internalSize} ${this._internalSize}">${this._renderCircle("rail")} ${this._renderCircle("progress")}</svg>`}</div>${this.showPercent ? e`<span>${this._correctedValue}%</span>` : t}`;
  }
};
s([o({
  reflect: !0,
  type: String
})], u.prototype, "mode", void 0), s([o({
  reflect: !0,
  type: String
})], u.prototype, "emphasis", void 0), s([o({
  reflect: !0,
  type: String
})], u.prototype, "size", void 0), s([o({
  reflect: !0,
  type: Boolean,
  attribute: "as-icon"
})], u.prototype, "asIcon", void 0), s([o({
  reflect: !0,
  attribute: "show-percent",
  type: Boolean
})], u.prototype, "showPercent", void 0), s([o({
  reflect: !0,
  type: Number
})], u.prototype, "value", void 0), u = s([a("zui-progress-ring")], u);
export { u as ProgressRing };
